// extracted by mini-css-extract-plugin
module.exports = {"button":"AddMinusButton_button__2RU3-","icon":"AddMinusButton_icon__2fF9J"};